export enum HomePageBannerSectionType {
  Header = 'Header',
  Title = 'Title',
  Subtitle = 'Subtitle',
  Description = 'Description',
  ActionTitle = 'ActionTitle',
}
export type HomePageBannerSectionDto = {
  type: HomePageBannerSectionType;
  value: string | null;
  link: string | null;
};
export type HomeBannerDto = {
  order: number;
  sourceSet: string[];
  sections: HomePageBannerSectionDto[];
};
